import { useEffect, useState } from 'react'
import Modal from '@/components/ui/Modal'
import { BottomSheet } from '@/components/ui/BottomSheet'
import { useIsCompact } from '@/hooks/useDevice'
import OrderTracking from '@/components/Order/OrderTracking'

interface TrackingSidebarProps {
  item: any
  fulfillments?: any[]
  onClear: () => void
  embedded?: boolean
}

export const TrackingSidebar = ({ item, fulfillments, onClear, embedded = false }: TrackingSidebarProps) => {
  const [isOpen, setIsOpen] = useState(true)
  const isCompact = useIsCompact()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const handleClose = () => {
    document.body.style.overflow = 'auto'
    setIsOpen(false)
    onClear()
  }

  if (!item) {
    return null
  }

  const body = <OrderTracking item={item} fulfillments={fulfillments} onClear={handleClose} />

  if (embedded) {
    return body
  }

  if (isCompact) {
    return (
      <BottomSheet isOpen={isOpen} onClose={handleClose} title="Order Tracking">
        {body}
      </BottomSheet>
    )
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Order Tracking" size="2xl">
      {body}
    </Modal>
  )
}

export default TrackingSidebar
